import { getListItemStyles } from "./MuiListItem.js";
import { getListItemInteractiveStyles } from "./MuiListItemButton.js";
const MuiMenuItem = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...getListItemStyles(theme),
      ...getListItemInteractiveStyles(theme)
    })
  }
};
export {
  MuiMenuItem
};
//# sourceMappingURL=MuiMenuItem.js.map
